import ButtonVariants from "@core-components/button/ButtonVariants";
import EPublicRoutes from "@core-types/routes.enum";
import useAppLanguage from "@hooks/language/useAppLanguage";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Flex } from "@mantine/core";

const HelpCenterBackButton = () => {
  const { locationUrlBuilder } = useAppLanguage();
  const { t } = useAppTranslation("pages.helpCenter");

  return (
    <Flex justify="center" className="my-14 w-full">
      <ButtonVariants.BackRounded
        href={locationUrlBuilder(EPublicRoutes.FAQ)}
        label={t("common.backToHelpCenter")}
      />
    </Flex>
  );
};

export default HelpCenterBackButton;
